import React from 'react';
import { Filter, ReferenceInput, SelectInput } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';
import UserAutocompleteInput from '../../../../commonComponents/UserAutocompleteInput';

const BoostersReportsFilter = (props) => (
  <Filter {...props}>
    <CustomDateInput label="Choose start date" source="start_date" start alwaysOn />
    <CustomDateInput label="Choose end date" source="end_date" end alwaysOn />
    <ReferenceInput label="Booster" source="booster_id" reference="admin/boosters" alwaysOn>
      <SelectInput optionText="name" />
    </ReferenceInput>
    <UserAutocompleteInput label="User ID" source="user_id" alwaysOn />
  </Filter>
);

export default BoostersReportsFilter;
